import axios from 'axios'
// console.log('desde config axios', process.env.VUE_APP_API)
axios.defaults.baseURL = process.env.VUE_APP_API
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (config.url === '/login') {
    delete config.headers.common.Authorization
  }
  return config
})
export default axios
